import { expVal } from '@atlassian/jira-feature-experiments';

export default {
	get(): boolean {
		return expVal('blu-6315-display-settings-a-part-1', 'isEnabled', false);
	},
};
